import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formattedNumber' })
export class FormattedNumberPipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) { }

    transform(value: number | string | null | undefined, locale: string): string | null {
        if (value == null) {
            return null;
        }
        return new Intl.NumberFormat(locale, { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(value));
    }

}